/**
 * Whether the draft's error state disables Publish.
 *
 * PSTUDIO-4242: while a validation pass is running, the compiler-derived errors
 * are the PREVIOUS pass's verdict and this pass may clear them, so they must
 * not stop the click from being queued. A node-number problem is different: it
 * is derived from the current rows (PSTUDIO-4000 / 3990), no pass can clear
 * it, and a click queued over it could only ever end refused.
 *
 * Takes the node-number verdict rather than the rows so this stays free of the
 * store's import graph (`findNodeNumberProblem` pulls in `table-store`).
 */
export const isDraftInvalidForPublish = ({
  validating,
  effectiveErrorCount,
  hasNodeNumberProblem,
}: {
  validating: boolean;
  effectiveErrorCount: number;
  hasNodeNumberProblem: boolean;
}): boolean => (validating ? hasNodeNumberProblem : effectiveErrorCount > 0);
